module.exports = __webpack_public_path__ + "img/1.fc85ae2e.png";